// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.month-heading {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr) 44px;
  align-items: center;
}

.month-step {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #232137;
  font-size: 1.8rem;
  line-height: 1;
  cursor: pointer;
}

.month-step:disabled {
  opacity: 0.3;
  cursor: default;
}

.month-step:focus-visible,
.month-dots button:focus-visible {
  outline: 2px solid #e72f44;
  outline-offset: -2px;
}

.month-dots {
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 360px;
  margin: 4px auto 0;
}

.month-dots button {
  display: grid;
  place-items: center;
  flex: 1 1;
  min-width: 0;
  max-width: 30px;
  height: 44px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.month-dots button::before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e6e6ee;
}

.month-dots button[aria-current=date]::before {
  background: #232137;
}

.month-dots button:disabled {
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/monthNavigation.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,+CAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;AACF;;AAEA;;EAEE,0BAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,eAAA;AACF","sourcesContent":[".month-heading {\n  display: grid;\n  grid-template-columns: 44px minmax(0, 1fr) 44px;\n  align-items: center;\n}\n\n.month-step {\n  width: 44px;\n  height: 44px;\n  display: grid;\n  place-items: center;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: #232137;\n  font-size: 1.8rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.month-step:disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.month-step:focus-visible,\n.month-dots button:focus-visible {\n  outline: 2px solid #e72f44;\n  outline-offset: -2px;\n}\n\n.month-dots {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  max-width: 360px;\n  margin: 4px auto 0;\n}\n\n.month-dots button {\n  display: grid;\n  place-items: center;\n  flex: 1 1 0;\n  min-width: 0;\n  max-width: 30px;\n  height: 44px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n}\n\n.month-dots button::before {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #e6e6ee;\n}\n\n.month-dots button[aria-current=\"date\"]::before {\n  background: #232137;\n}\n\n.month-dots button:disabled {\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
